module.exports = __webpack_public_path__ + "img/05.1369fd44.jpg";